export default __webpack_public_path__ + "static/media/ASHUZA_KASUMBE_PASCAL_CV.6f206bb4.pdf";